import { getTaxTypeShortLabel } from 'src/app/constants/tax.constants';

/**
 * Column/line label for tax on an enrollment agreement, built from the studio's
 * configured taxes (configuration:tax rows from loadStudioConfig?config_field_name=field_tax_ref).
 *
 * Active taxes contribute their short type label, de-duplicated, joined with
 * " + " (e.g. "GST + PST"). `fallback` is what prints when the studio has no
 * tax configuration: each paper form keeps its own historical wording there.
 */
export function agreementTaxLabel(taxConfig: any[] | null | undefined, fallback: string): string {
  if (!Array.isArray(taxConfig) || taxConfig.length === 0) return fallback;

  const labels: string[] = [];
  for (const tax of taxConfig) {
    const val = (f: string) => Array.isArray(tax?.[f]) ? tax[f][0]?.value : tax?.[f];
    const status = val('field_tax_status');
    if (status !== '1' && status !== 'true' && status !== true) continue;
    const label = getTaxTypeShortLabel(val('field_tax_type'), 'Tax');
    if (!labels.includes(label)) labels.push(label);
  }
  return labels.length ? labels.join(' + ') : fallback;
}
